import { Checkbox } from "@/components/ui/checkbox";

export default function CheckboxGrid({ items = [], selected = [], onChange, testIdPrefix }) {
  const toggle = (item) => {
    if (selected.includes(item)) {
      onChange(selected.filter((i) => i !== item));
    } else {
      onChange([...selected, item]);
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
      {items.map((item, idx) => (
        <label
          key={item}
          className="flex items-start gap-2 p-2 rounded-md border border-border hover:bg-accent/50 cursor-pointer transition-colors"
          data-testid={`${testIdPrefix}-option-${idx}`}
        >
          <Checkbox
            checked={selected.includes(item)}
            onCheckedChange={() => toggle(item)}
            className="mt-0.5"
          />
          <span className="text-sm text-foreground leading-snug">{item}</span>
        </label>
      ))}
    </div>
  );
}
